/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentExportJobs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Export Job API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, December 16, 2019 - 01:51:12 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      12/16/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const ExportJobs = {
    all: (companyid, exporttypeid) => requests.get(`/ExportJobs?companyid=${companyid}&exporttypeid=${exporttypeid}`),
    get: exportjobid => requests.get(`/ExportJob/${exportjobid}`),
    create: exportjob => requests.post(`/ExportJobs`, exportjob),
    update: (exportjobid, exportjob) => requests.put(`/ExportJob/${exportjobid}`, exportjob),
    delete: exportjobid => requests.del(`/ExportJob/${exportjobid}`),
    getJobFilters: exportjobid => requests.get(`/ExportJobFilters/${exportjobid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentExportJobs.js